<div
  #centerSlot
  [attr.uislot]="settings().outlets?.CENTER ?? ROUTE_OUTLETS.CENTER"
  select="[center]"
  class="flex flex-col"
>
  @if (settings().outlets?.CENTER) {
    <ng-content select="[center]"></ng-content>

    @if (settings().useRouterOutlet) {
      <router-outlet
        class="hidden"
        [name]="$safeNavigationMigration(settings().outlets?.CENTER)!"
      ></router-outlet>
    }
  } @else {
    <router-outlet class="hidden"></router-outlet>
  }
</div>

@if (settings().type?.includes('left')) {
  @if (settings().handles?.includes('left')) {
    <div
      #leftHandle
      uihandle="vertical"
      uislot="leftHandle"
      select="[leftHandle]"
      draggable="true"
      (dragstart)="startDrag($event, '--left-area-width')"
      (drag)="drag($event)"
      (dragend)="endDrag($event)"
      (dblclick)="toggle('--left-area-width')"
    ></div>
  }
  <div #leftSlot [attr.uislot]="settings().outlets?.LEFT ?? ROUTE_OUTLETS.LEFT">
    <ng-content select="[left]"></ng-content>

    @if (settings().useRouterOutlet) {
      <router-outlet
        class="hidden"
        [name]="settings().outlets?.LEFT ?? ROUTE_OUTLETS.LEFT"
      ></router-outlet>
    }
  </div>
}
@if (settings().type?.includes('right')) {
  @if (settings().handles?.includes('right')) {
    <div
      #rightHandle
      uihandle
      uislot="rightHandle"
      select="[rightHandle]"
      draggable="true"
      (dragstart)="startDrag($event, '--right-area-width')"
      (drag)="drag($event)"
      (dragend)="endDrag($event)"
      (dblclick)="toggle('--right-area-width')"
    ></div>
  }
  <div
    #rightSlot
    [attr.uislot]="settings().outlets?.RIGHT ?? ROUTE_OUTLETS.RIGHT"
  >
    <ng-content select="[right]"></ng-content>

    @if (settings().useRouterOutlet) {
      <router-outlet
        class="hidden"
        [name]="settings().outlets?.RIGHT ?? ROUTE_OUTLETS.RIGHT"
      ></router-outlet>
    }
  </div>
}
@if (settings().type?.includes('top')) {
  <div
    class="z-1"
    #topSlot
    [attr.uislot]="settings().outlets?.TOP ?? ROUTE_OUTLETS.TOP"
  >
    <ng-content select="[top]"></ng-content>

    @if (settings().useRouterOutlet) {
      <router-outlet
        class="hidden"
        [name]="settings().outlets?.TOP ?? ROUTE_OUTLETS.TOP"
      ></router-outlet>
    }
  </div>
  @if (settings().handles?.includes('top')) {
    <div
      #topHandle
      uihandle
      uislot="topHandle"
      select="[topHandle]"
      draggable="true"
      (dragstart)="startDrag($event, '--top-area-height')"
      (drag)="drag($event)"
      (dragend)="endDrag($event)"
      (dblclick)="toggle('--top-area-height')"
    ></div>
  }
}
@if (settings().type?.includes('bottom')) {
  @if (settings().handles?.includes('bottom')) {
    <div
      #bottomHandle
      uihandle
      uislot="bottomHandle"
      select="[bottomHandle]"
      draggable="true"
      (dragstart)="startDrag($event, '--bottom-area-height')"
      (drag)="drag($event)"
      (dragend)="endDrag($event)"
      (dblclick)="toggle('--bottom-area-height')"
    ></div>
  }
  <div
    #bottomSlot
    [attr.uislot]="settings().outlets?.BOTTOM ?? ROUTE_OUTLETS.BOTTOM"
  >
    <ng-content select="[bottom]"></ng-content>

    @if (settings().useRouterOutlet) {
      <router-outlet
        class="hidden"
        [name]="settings().outlets?.BOTTOM ?? ROUTE_OUTLETS.BOTTOM"
      ></router-outlet>
    }
  </div>
}
